import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import logolight from "../../assets/images/mrm-logo.png";
import logodark from "../../assets/images/mrm-logo.png";
import "../../Layout/VerticalLayout/Header.css";

import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Form,
  Input,
  FormFeedback,
  Label,
  Spinner,
} from "reactstrap";

import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// Custom authentication functions
import { loginAdmin } from "../../services/apiServices";
import { setAuthData } from "../../helpers/auth-helpers";

const Login = (props) => {
  document.title = "Login | mrmto";
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .required("Please Enter Your Email")
        .email("Please enter a valid email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      setError(null);

      try {
        // Call the loginAdmin API function
        const response = await loginAdmin({
          email: values.email,
          password: values.password,
        });
        console.log("ggggggggggggggg", response);
        if (response.status && response.data.authToken) {
          console.log("Login response:", response);

          // Map the admin data structure to match what the profile page expects
          const adminData = {
            _id: response.data._id, // Map id to _id
            name: response.data.name,
            email: response.data.email,
            isActive: response.data.isActive,
          };

          // Store token and user data in localStorage
          setAuthData(response.data.authToken, adminData);

          // Redirect to dashboard
          props.router.navigate("/analytics/dashboard");
        } else {
          setError("Login failed. Please check your credentials.");
        }
      } catch (err) {
        console.error("Login error:", err);
        setError(
          err.response?.data?.message || "Login failed. Please try again.",
        );
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    document.body.className = "";
    return function cleanup() {
      document.body.className = "";
    };
  }, []);

  return (
    <React.Fragment>
      <div className="account-pages min-vh-100 d-flex align-items-center justify-content-center">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card>
                <CardBody className="p-4">
                  <div>
                    <div>
                      <div className="text-center mb-4">
                        <Link to="/">
                          <img
                            src={logodark}
                            alt=""
                            className="auth-logo logo-dark mx-auto mrm-logo"
                          />
                          <img
                            src={logolight}
                            alt=""
                            className="auth-logo logo-light mx-auto mrm-logo"
                          />
                        </Link>
                      </div>
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}>
                        {error && (
                          <Alert color="danger">
                            <div>{error}</div>
                          </Alert>
                        )}
                        <Row>
                          <Col md={12}>
                            <div className="mb-4">
                              <Label className="form-label">Email</Label>
                              <Input
                                name="email"
                                className="form-control"
                                placeholder="Enter email"
                                type="email"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.email || ""}
                                invalid={
                                  validation.touched.email &&
                                  validation.errors.email
                                    ? true
                                    : false
                                }
                                disabled={loading}
                              />
                              {validation.touched.email &&
                              validation.errors.email ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.email}</div>
                                </FormFeedback>
                              ) : null}
                            </div>
                            <div className="mb-4">
                              <Label className="form-label">Password</Label>
                              <Input
                                name="password"
                                value={validation.values.password || ""}
                                type="password"
                                placeholder="Enter Password"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                invalid={
                                  validation.touched.password &&
                                  validation.errors.password
                                    ? true
                                    : false
                                }
                                disabled={loading}
                              />
                              {validation.touched.password &&
                              validation.errors.password ? (
                                <FormFeedback type="invalid">
                                  <div>{validation.errors.password}</div>
                                </FormFeedback>
                              ) : null}
                            </div>

                            <div className="d-grid mt-4">
                              <button
                                className="btn btn-primary waves-effect waves-light"
                                type="submit"
                                disabled={loading}>
                                {loading ? (
                                  <>
                                    <Spinner size="sm" className="me-2" />
                                    Signing In...
                                  </>
                                ) : (
                                  "Log In"
                                )}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </Form>
                    </div>
                  </div>
                </CardBody>
              </Card>
              <div className="mt-4 text-center">
                <p>© {new Date().getFullYear()} mrmto</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  router: PropTypes.object,
};
